import i18n from "i18next";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

import ENV from "config/Env";
import { ApiInstance } from "utils/Api";
import { getBrowserLanguage } from "utils/common";

import type { HttpBackendOptions, RequestCallback } from "i18next-http-backend";

const defaultLanguage = getBrowserLanguage();
const devOptionsHandler = (args: unknown) => {
  if (!Array.isArray(args)) return { args };

  let options = { defaultValue: "" };
  if (typeof args[2] === "object") options = { ...args[2] };
  if (typeof args[0] === "string") options.defaultValue = args[0];

  return options;
};

i18n
  .use(Backend)
  .use(initReactI18next)
  .init<HttpBackendOptions>(
    {
      fallbackLng: false,
      preload: [defaultLanguage],
      returnObjects: true,
      overloadTranslationOptionHandler: process.env.NODE_ENV !== "production" ? devOptionsHandler : undefined,
      lng: defaultLanguage,
      ns: ["translations"],
      defaultNS: "translations",
      debug: false,
      interpolation: {
        escapeValue: false
      },
      load: "currentOnly",
      backend: {
        request: async (_: HttpBackendOptions, __: string, ____: string, callback: RequestCallback) => {
          try {
            const response = await ApiInstance.post("/translations/list", { language_code: i18n.language, platform: "v8_" }, ENV.systemBaseURLv2);
            callback(null, { data: response.data.translations, status: 200 });
          } catch (err) {
            callback(err, null);
          }
        }
      },
      react: {
        useSuspense: false
      }
    },
    (err, _t) => {
      if (err) console.error("failed to load translations:", err);
    }
  );

export default i18n;
